export default "__VITE_ASSET__DjdBG7qg__"